"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  genericError: 'Sorry, something went wrong!',
  offerIsNotAvailable: 'Offer is not available at the moment.',
  selectedQuantityIsNotAvailable: 'Selected quantity is not available due to stock limitations.'
};
const translationsNamespace = exports.translationsNamespace = 'error-notification';
